"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./Question.css");
var _react = require("react");
var _InterstitialScreen = _interopRequireDefault(require("../InterstitialScreen/InterstitialScreen"));
var _TextAnswer = _interopRequireDefault(require("../Answers/TextAnswer/TextAnswer"));
var _AnswerType = require("../../../utility/Forms/AnswerType");
var _SlideDirection = require("../../../utility/Forms/SlideDirection");
var _ListAnswer = _interopRequireDefault(require("../Answers/ListAnswer/ListAnswer"));
var _ContinueButton = _interopRequireDefault(require("../ContinueButton/ContinueButton"));
var _ValidationFormat = require("../../../utility/Forms/ValidationFormat");
var _SelectAnswer = _interopRequireDefault(require("../Answers/SelectAnswer/SelectAnswer"));
var _DateAnswer = _interopRequireDefault(require("../Answers/DateAnswer/DateAnswer"));
var _FormulaParser = _interopRequireDefault(require("../../../utility/Forms/FormulaParser"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Question = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _useState = (0, _react.useState)(props.answers),
    _useState2 = _slicedToArray(_useState, 2),
    answers = _useState2[0],
    setAnswers = _useState2[1];
  var _useState3 = (0, _react.useState)(props.invalidAnswerSubmitted),
    _useState4 = _slicedToArray(_useState3, 2),
    invalidAnswerSubmitted = _useState4[0],
    setInvalidAnswerSubmitted = _useState4[1];
  var _useState5 = (0, _react.useState)(props.slideDirection),
    _useState6 = _slicedToArray(_useState5, 2),
    slideDirection = _useState6[0],
    setSlideDirection = _useState6[1];
  var interpolationRegex = /[^{\}]+(?=})/g;
  (0, _react.useEffect)(function () {
    setAnswers(props.answers);
    setSlideDirection(props.slideDirection);
    if (invalidAnswerSubmitted !== props.invalidAnswerSubmitted) {
      setInvalidAnswerSubmitted(props.invalidAnswerSubmitted);
    }
  }, [props.answers, props.slideDirection, props.invalidAnswerSubmitted]);
  function renderAnswer() {
    switch (props.data.answerType) {
      case _AnswerType.AnswerType.Text:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextAnswer.default, _objectSpread(_objectSpread({}, props), {}, {
          interpolate: interpolate
        }));
      case _AnswerType.AnswerType.List:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListAnswer.default, _objectSpread({}, props));
      case _AnswerType.AnswerType.Select:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectAnswer.default, _objectSpread({}, props));
      case _AnswerType.AnswerType.Date:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateAnswer.default, _objectSpread({}, props));
      default:
        return null;
    }
  }
  function replaceWithValue(variableName, entireString) {
    var keyToReplace = "{" + variableName + "}";
    var valueToReplace = answers[variableName];
    if (!valueToReplace) {
      return entireString;
    }
    return entireString.replaceAll(keyToReplace, valueToReplace);
  }
  function interpolate(text) {
    if (!text) {
      return text;
    }
    var interpolatedText = text;
    var matches = text.match(interpolationRegex);
    if (!matches) {
      return text;
    }
    var _iterator = _createForOfIteratorHelper(matches),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var match = _step.value;
        interpolatedText = replaceWithValue(match, interpolatedText);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return interpolatedText;
  }
  function getValidationMessage() {
    if (props.data.validationFormat === _ValidationFormat.ValidationFormat.Email) {
      return "Hmm... that doesn't look like an email address";
    } else if (props.data.validationFormat === _ValidationFormat.ValidationFormat.PhoneNumber) {
      return "Hmm... that doesn't look like a phone number";
    } else if (props.data.validationFormat === _ValidationFormat.ValidationFormat.ZipCode) {
      return "Hmm... that doesn't look like a zip code";
    } else if (props.data.validationFormat === _ValidationFormat.ValidationFormat.Currency) {
      return "Hmm, that doesn't look like a real amount";
    } else {
      return "Please provide a valid answer";
    }
  }
  function renderValidationError() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "validation-warning",
      role: "alert",
      children: getValidationMessage()
    });
  }
  function getPrompt() {
    if (props.data.prompt.startsWith("=")) {
      return _FormulaParser.default.executeFormula(props.data.prompt, answers);
    } else {
      return interpolate(props.data.prompt);
    }
  }
  function renderQuestion() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: forwardedRef,
      "data-testid": props.data.name,
      className: "full-screen-question ".concat(slideDirection === _SlideDirection.SlideDirection.Up ? "slide-up-from-bottom" : "slide-down-from-top"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "question-content",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          className: "question-number-and-prompt",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "question-number",
            children: [props.questionDisplayNumber, "."]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "question-prompt",
            children: [getPrompt(), " ", props.data.required ? "*" : null]
          })]
        }), renderAnswer(), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex-row continue-button-wrapper",
          children: invalidAnswerSubmitted ? renderValidationError() : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContinueButton.default, _objectSpread(_objectSpread({}, props), {}, {
            showPressEnterMessage: props.data.answerType === _AnswerType.AnswerType.Text ? true : false
          }))
        })]
      })
    });
  }
  if (props.data.heading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InterstitialScreen.default, _objectSpread({
      ref: forwardedRef
    }, props));
  } else {
    return renderQuestion();
  }
});
var _default = Question;
exports.default = _default;